import React, { useState,useEffect } from "react";
import { FaSave } from "react-icons/fa";
import { AiOutlineDownload } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import addpeopleapi from '../api/addpeopleapi';
import loginapi from '../api/accesstokenrouterapi';
import { FaPlusCircle } from "react-icons/fa";
import { useParams } from "react-router-dom";
import { APISERVERURL } from '../APIServerURL';

import SelectedImages from '../components/SelectedImages'

const EditPeoplePage = ({ accessToken,setAccessToken, setRefreshFailed }) => {
     const navigate = useNavigate();  
      const { form_id} = useParams();
      
    const [images,setImages]=useState([]);
    const [isLoading,setIsloading]=useState(false);
    
    const [name, setName] = useState("");
    const [peopleGroup, setPeopleGroup] = useState([]);
    const [qualification, setQualification] = useState("");
    const [designation, setDesignation] = useState("");
    const [contactNumberToDisplay, setContactNumberToDisplay] = useState("");
    const [email, setEmail] = useState("");
    const [publishInWebsite, setPublishInWebsite] = useState("");


    const [imgName,setImgName]=useState('');
    const handleAddNew=async (e)=>
        {
           e.preventDefault();
           
           
            let formData = new FormData();    //formdata object
            formData.append("form_id", form_id);
            formData.append("name", name);
            formData.append("peopleGroup", JSON.stringify(peopleGroup)); // since it's an array
            formData.append("qualification", qualification);
            formData.append("designation", designation);
            formData.append("contactNumberToDisplay", contactNumberToDisplay);
            formData.append("email", email);
            formData.append("publishInWebsite", publishInWebsite);
      
            
      
            Object.values(images).forEach(file=>{
              formData.append("images", file);
            });
            const config = {     
                headers: { 'content-type': 'multipart/form-data' }
            }
      
          
           //call api to save the form  

            setIsloading(true);
            try{
            const response= await addpeopleapi.post('/updatePeople',formData,{headers:{'Authorization':`Bearer ${accessToken}`}});      
            setIsloading(false);
            if(response.data.status!='OK')
            {
            alert(JSON.stringify(response.data));
            }
            else{
              alert('People Updated!');
              navigate('/allpeople');
            }
            
            }
            catch(err)
            {
                try{
                const config = { withCredentials: true };
                const x=await loginapi.get('/getAccessToken',config);
                //alert(JSON.stringify(x['data']['accessToken']));
                
                const nat=x['data']['accessToken'];
                setAccessToken(nat);
                //console.log(`ne at ${nat}`);
                //console.log(`Second at:${accessToken}`);
                try{       
                    const response= await addpeopleapi.post('/updatePeople',formData,{headers:{'Authorization':`Bearer ${nat}`}});      
                    if(response.data.status!='OK')
                      {
                      alert(JSON.stringify(response.data));
                      }
                      else{
                        alert('People updated!');
                        navigate('/allpeople');
                      }
                    //navigate('/');
                }
                catch(err)
                {
                    alert('unusual error newposts.js');
                    setIsloading(false);
                    //navigate('/');
                }
                }
                catch(err)
                {
                alert('failed');
                setIsloading(false);
                //setError(JSON.stringify(err));
                //navigate('/');
                }

            }
          }

    function addToImageList(selectedFiles)
    {
        const newImages=[...images,...selectedFiles];
        setImages(newImages);
        console.log(newImages.length);
    }

    const handleGoBack=(e)=>{
        e.preventDefault();
    }
  
    const setRegistrationForm = (form) => {
      setName(form.name || "");
      setPeopleGroup(form.peopleGroup || []);
      setQualification(form.qualification || "");
      setDesignation(form.designation || "");
      setContactNumberToDisplay(form.contactNumberToDisplay || "");
      setEmail(form.email || "");
      setPublishInWebsite(form.publishInWebsite || "");
      setImgName(form.images && form.images.length > 0 ? form.images[0] : '');
    };

    const loadForm=async ()=>{
      setIsloading(true);
        try{       
          //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
          const response=await addpeopleapi.post('/getPeople',{form_id},{headers:{'Authorization':`Bearer ${accessToken}`}});  
          setRegistrationForm(response.data.registrationForm);//JSON.stringify(response.data.registrationForm);
          setIsloading(false);
          //alert(JSON.stringify(response.data));
          }
          catch(err)
          {
            if( err.response.status===403)
              {
                navigate(`/accessdenied`); 
              }
            try{
              const config = { withCredentials: true };
              const x=await loginapi.get('/getAccessToken',config);            
              const nat=x['data']['accessToken'];
              const lt=x['data']['loginType'];
              //alert(nat);
              setAccessToken(nat);
              setRefreshFailed(false);  
                      
             
                if(lt.toLowerCase()==="admin")
                  {
                        try{       
                          //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                          const response=await addpeopleapi.post('/getPeople',{form_id},{headers:{'Authorization':`Bearer ${nat}`}});   
                          setRegistrationForm(response.data.registrationForm);//JSON.stringify(response.data.registrationForm);
                          setIsloading(false);
                          //alert(JSON.stringify(response.data));
                      }
                      catch(err)
                      {
                        if( err.response.status===403)
                          {
                            navigate(`/accessdenied`); 
                          }
                        //alert('refresh failed unusual'+JSON.stringify(err));
                        setAccessToken('');
                        setRefreshFailed(true);  
                      }
                    }
              }
              catch(err)
              {
                //alert('dd');
                setAccessToken(''); 
                setRefreshFailed(true);              
              }
          }         
           finally
              {
                //setIsAppLoaded(true);
                //alert('app loaded'+accessToken);
                setIsloading(false);
              }
      }
    
      useEffect(()=>{
        loadForm();
      },[]);

      


    return (
        <main className="w-full">
        <div className="flex flex-col items-center w-full">


         <div className="w-full relative py-1">
            {/* Heading */}
            <h1 className="text-2xl  text-gray-400 text-center">EDIT MEMBER DETAILS</h1>
            <p className='text-center text-xs'>
            </p>
          </div>
        
        <div className="flex flex-col w-[98%] max-w-[1200px]  justify-center items-center bg-gray-100">
            <form className='w-[98%] max-w-[600px] ' onSubmit={handleAddNew}>

            <div className="mt-4">
  <label>Name</label>
  <input
    type="text"
    value={name}
    onChange={(e) => setName(e.target.value)}
    className={`border-b-2 border-blue-500 p-2 w-full bg-transparent`}
  />
</div>


<div className="mt-4">
  <label>Group</label>
  <select
    multiple
    value={peopleGroup}
    onChange={(e) =>
      setPeopleGroup(Array.from(e.target.selectedOptions, (option) => option.value))
    }
    className="border-b-2 border-blue-500 p-2 w-full bg-transparent h-48"
  >
    <option value="management">Management</option>
    <option value="primary">Primary</option>
    <option value="middle">Middle</option>
    <option value="secondary">Secondary</option>
    <option value="sr_secondary">Sr. Secondary</option>
    <option value="office_staff">Office Staff</option>
    <option value="support_staff">Support Staff</option>
  </select>
</div>

<div className="mt-4">
  <label>Qualification</label>
  <input
    type="text"
    value={qualification}
    onChange={(e) => setQualification(e.target.value)}
    className={`border-b-2 border-blue-500 p-2 w-full bg-transparent`}
  />
</div>

<div className="mt-4">
  <label>Designation</label>
  <input
    type="text"
    value={designation}
    onChange={(e) => setDesignation(e.target.value)}
    className={`border-b-2 border-blue-500 p-2 w-full bg-transparent`}
  />
</div>

<div className="mt-4">
  <label>Contact Number to Display</label>
  <input
    type="text"
    value={contactNumberToDisplay}
    onChange={(e) => setContactNumberToDisplay(e.target.value)}
    className={`border-b-2 border-blue-500 p-2 w-full bg-transparent`}
  />
</div>

<div className="mt-4">
  <label>Email</label>
  <input
    type="email"
    value={email}
    onChange={(e) => setEmail(e.target.value)}
    className={`border-b-2 border-blue-500 p-2 w-full bg-transparent`}
  />
</div>

<div className="mt-4">
  <label>Publish in Website</label>
  <select
    value={publishInWebsite}
    onChange={(e) => setPublishInWebsite(e.target.value)}
    className={`border-b-2 border-blue-500 p-2 w-full bg-transparent`}
  >
    <option value="">Please Select</option>
    <option value="YES">YES</option>
    <option value="NO">NO</option>
  </select>
</div>
<div>
  <p>Uploaded Image:</p>
 {imgName && imgName!='' &&(<div className="block w-full h-[300px] overflow-hidden">
    <img
      src={`${APISERVERURL}/img/${imgName}`}
      alt="placeholder"
      className="w-65 h-full object-cover transform hover:scale-110 transition-transform duration-500"
    />
  </div>)}

  {(!imgName ||imgName=='')&&(<div className="block w-full h-[300px] overflow-hidden">
    <p>No Image uploaded!</p>
  </div>)}

</div>
            
            <input className="marginTop" type='file' id="fuPhotos" name="uploadedPhotos" multiple
            accept="image/png, image/jpg, image/jpeg"
            onChange={(e)=>{addToImageList(e.target.files)}}
            ></input>
            <SelectedImages
            images={images}
            setImages={setImages}
            >
            </SelectedImages>

            <div className="flex justify-between mt-6 mb-6">
            <button
                onClick={handleGoBack}
                className="bg-gray-500 hover:bg-gray-700 text-white font-semibold py-1 px-6 rounded-2xl shadow-md transition"
            >
                BACK
            </button>
            <button
                type="submit"
                className="bg-blue-600 hover:bg-blue-800 text-white font-semibold py-1 px-6 rounded-2xl shadow-md transition"
            >
                UPDATE
            </button>
            </div>

            </form>
        </div>




        </div>
        </main>
    );
};

export default EditPeoplePage;
